export default "__VITE_ASSET__312226d5__"